import { forwardRef } from "react";
import type { HTMLAttributes } from "react";

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: "success" | "warning" | "danger" | "info" | "neutral";
  size?: "sm" | "md";
  children: React.ReactNode;
}

const Badge = forwardRef<HTMLSpanElement, BadgeProps>(
  (
    { variant = "neutral", size = "md", className = "", children, ...props },
    ref
  ) => {
    const baseStyles =
      "inline-flex items-center font-bold uppercase tracking-wider border-2";

    const variants = {
      success: "bg-green-500 text-black border-green-500",
      warning: "bg-yellow-400 text-black border-yellow-400",
      danger: "bg-red-600 text-white border-red-600",
      info: "bg-blue-500 text-white border-blue-500",
      neutral: "bg-gray-200 text-black border-gray-200",
    };

    const sizes = {
      sm: "px-2 py-0.5 text-xs",
      md: "px-3 py-1 text-xs",
    };

    return (
      <span
        ref={ref}
        className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
        style={{ fontFamily: "'Courier New', monospace" }}
        {...props}
      >
        {children}
      </span>
    );
  }
);

Badge.displayName = "Badge";

export default Badge;
